import { useColorTokens } from "@tvg/design-system";
import React from "react";
import { SVG } from "./styled-components";

interface Props {
  qaLabel: string;
}

const LoadingMask = ({ qaLabel }: Props) => {
  const greyBgColor = useColorTokens("content.loadingDefault");
  return (
    <SVG width="100%" height="48" fill={greyBgColor} data-qa-label={qaLabel}>
      <rect x="8" y="8" width="145" height="32" fill="#000" rx="25" />
      <rect x="168" y="16" width="135" height="16" fill="#000" rx="1" />
      <rect x="328" y="16" width="135" height="16" fill="#000" rx="1" />
      <rect x="488" y="16" width="135" height="16" fill="#000" rx="1" />
    </SVG>
  );
};

export default LoadingMask;
